import React from 'react';
import appNavigationNames, { withActiveTab } from '../../utils/appNavigationNames';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { getIntl } from '../../utils/intl';
import { screens } from '../screens/Tabs/Organization';
import { MaybeDrawerLayout } from '../shared/MaybeSideNavLayout';
import { getHeader, mobileHeaderConfigs } from '../v2BaseComponents/Header';
import { colors } from '../../utils/theme';
import { useCapturedUrlUTMParameters } from '../../hooks/useUrlUTMParameters';

const intl = getIntl('organization-navigator', {
    root: 'Organization',
    user: 'Organization User',
    editUser: 'Edit Organization User',
    addOrganizationInvitation: 'Add Agent Invitation',
    organizationInvitation: 'Agent Invitation',
    clientInvitation: 'Client Invitation',
    addClientInvitation: 'Add Client Invitation',
    addGroup: 'Add Group',
    editGroup: 'Edit Group',
    group: 'Group Details',
    addInvitationDefinition: 'Add Invitation Template',
    editInvitationDefinition: 'Edit Invitation Template',
    invitationDefinition: 'Invitation Template',
    editClientBillingBranding: 'Edit Client Billing Branding',
});

const Stack = createNativeStackNavigator();

const OrganizationNavigation = () => {
    const capturedUrlUTMParameters = useCapturedUrlUTMParameters();

    return (
        <MaybeDrawerLayout>
            <Stack.Navigator initialRouteName={appNavigationNames.resources.root}>
                <Stack.Screen
                    options={{
                        header: getHeader({ mobile: mobileHeaderConfigs.logo, breadCrumbs: [] }),
                        title: intl('root'),
                        contentStyle: {
                            backgroundColor: colors.Background,
                        },
                    }}
                    name={appNavigationNames.organization.root}
                    component={screens.OrganizationScreen}
                    initialParams={capturedUrlUTMParameters}
                />
                <Stack.Screen
                    options={{
                        header: getHeader({ mobile: mobileHeaderConfigs.logo }),
                        title: intl('addOrganizationInvitation'),
                        contentStyle: {
                            backgroundColor: colors.Background,
                        },
                    }}
                    name={appNavigationNames.organization.addOrganizationInvitation}
                    component={screens.AddOrganizationInvitationScreen}
                    initialParams={capturedUrlUTMParameters}
                />
                <Stack.Screen
                    options={{
                        header: getHeader({ mobile: mobileHeaderConfigs.logo }),
                        title: intl('organizationInvitation'),
                        contentStyle: {
                            backgroundColor: colors.Background,
                        },
                    }}
                    name={appNavigationNames.organization.organizationInvitation}
                    component={screens.OrganizationInvitationScreen}
                    initialParams={capturedUrlUTMParameters}
                />
                <Stack.Screen
                    options={{
                        header: getHeader({ mobile: mobileHeaderConfigs.logo }),
                        title: intl('user'),
                        contentStyle: {
                            backgroundColor: colors.Background,
                        },
                    }}
                    name={appNavigationNames.organization.user}
                    component={screens.UserScreen}
                    initialParams={capturedUrlUTMParameters}
                />
                <Stack.Screen
                    options={{
                        header: getHeader({ mobile: mobileHeaderConfigs.logo }),
                        title: intl('editUser'),
                        contentStyle: {
                            backgroundColor: colors.Background,
                        },
                    }}
                    name={appNavigationNames.organization.editUser}
                    component={screens.EditUserScreen}
                    initialParams={capturedUrlUTMParameters}
                />
                <Stack.Screen
                    options={{
                        header: getHeader({ mobile: mobileHeaderConfigs.logo, breadCrumbs: [] }),
                        title: intl('addGroup'),
                        contentStyle: {
                            backgroundColor: colors.Background,
                        },
                    }}
                    name={appNavigationNames.organization.addGroup}
                    component={screens.AddGroupScreen}
                    initialParams={capturedUrlUTMParameters}
                />
                <Stack.Screen
                    options={{
                        header: getHeader({ mobile: mobileHeaderConfigs.logo, breadCrumbs: [] }),
                        title: intl('editGroup'),
                        contentStyle: {
                            backgroundColor: colors.Background,
                        },
                    }}
                    name={appNavigationNames.organization.editGroup}
                    component={screens.EditGroupScreen}
                    initialParams={capturedUrlUTMParameters}
                />
                <Stack.Screen
                    options={{
                        header: getHeader({ mobile: mobileHeaderConfigs.logo, breadCrumbs: [] }),
                        title: intl('group'),
                        contentStyle: {
                            backgroundColor: colors.Background,
                        },
                    }}
                    name={appNavigationNames.organization.group}
                    component={screens.GroupScreen}
                    initialParams={capturedUrlUTMParameters}
                />
                <Stack.Screen
                    options={{
                        header: getHeader({ mobile: mobileHeaderConfigs.logo, breadCrumbs: [] }),
                        title: intl('addInvitationDefinition'),
                        contentStyle: {
                            backgroundColor: colors.Background,
                        },
                    }}
                    name={appNavigationNames.organization.addInvitationDefinition}
                    component={screens.AddInvitationDefinitionScreen}
                    initialParams={capturedUrlUTMParameters}
                />
                <Stack.Screen
                    options={{
                        header: getHeader({ mobile: mobileHeaderConfigs.logo, breadCrumbs: [] }),
                        title: intl('editInvitationDefinition'),
                        contentStyle: {
                            backgroundColor: colors.Background,
                        },
                    }}
                    name={appNavigationNames.organization.editInvitationDefinition}
                    component={screens.EditInvitationDefinitionScreen}
                    initialParams={capturedUrlUTMParameters}
                />
                <Stack.Screen
                    options={{
                        header: getHeader({ mobile: mobileHeaderConfigs.logo, breadCrumbs: [] }),
                        title: intl('invitationDefinition'),
                        contentStyle: {
                            backgroundColor: colors.Background,
                        },
                    }}
                    name={appNavigationNames.organization.invitationDefinition}
                    component={screens.InvitationDefinitionScreen}
                    initialParams={capturedUrlUTMParameters}
                />
                <Stack.Screen
                    options={{
                        header: getHeader({ mobile: mobileHeaderConfigs.logo, breadCrumbs: [] }),
                        title: intl('editClientBillingBranding'),
                        contentStyle: {
                            backgroundColor: colors.Background,
                        },
                    }}
                    name={appNavigationNames.organization.editClientBillingBranding}
                    component={screens.EditClientBillingBrandingScreen}
                    initialParams={capturedUrlUTMParameters}
                />
            </Stack.Navigator>
        </MaybeDrawerLayout>
    );
};

export default withActiveTab(OrganizationNavigation, 'resources');
